import { Box, Flex, Spinner, useColorMode } from '@chakra-ui/react'
import { Moment } from 'config'
import { useReport } from 'hooks'
import Apex from 'react-apexcharts'

export default function DistributorsMonthlyGrowthChart({ period, ...props }){

    const { colorMode } = useColorMode()
    const report = useReport('distributors_monthly_growth', period)

    const dates = report.data?.data?.map(item => item.date)
    const values = report.data?.data?.map(item => item.monthly_growth)

    const series = [
        {
            name: 'Novos núcleos',
            data: values
        }
    ]

    const options = {
        theme: { 
            mode: colorMode,
            palette: 'palette2'
        },
        title: {
            text: "Crescimento de núcleos por período",
            align: 'center'
        },
        subtitle: {
            text: `Com dados de ${Moment(report.data?.metadata?.starts).format('LL')} até ${Moment(report.data?.metadata?.ends).format('LL')} | Última atualização ${Moment(report.data?.metadata?.updated_at).calendar()}`,
            align: 'center'
        },
        chart: { 
            height: 350, 
            type: 'area', 
            background: 'transparent',
            locales: [require('apexcharts/dist/locales/pt.json')],
            defaultLocale: 'pt',
            zoom: { 
                enabled: true 
            }, 
            animations: { 
                enabled: true, 
                easing: 'easeinout', 
                animateGradually: {
                    enabled: true,
                    delay: 150 
                },
                dynamicAnimation: {
                    enabled: true,
                    speed: 350
                }
            } 
        },
        dataLabels: { 
            enabled: true 
        },
        stroke: { 
            curve: 'smooth'
        },
        grid: { 
            show: false 
        },
        xaxis: { 
            type: 'datetime', 
            categories: dates 
        },
        yaxis: {
            show: false
        },
        tooltip: { 
            x: { 
                format: 'MM/yy' 
            }, 
        }
    }

    // Loading state
    if(report.isLoading) return <Flex w="100%" h={350} alignItems="center" justifyContent="center"><Spinner /></Flex>

    // Chart
    return <Apex options={options} series={series} type="area" height={350} />
}